import React, { Component } from 'react';
import MediaQuery from 'react-responsive';

import './JOSM.css';
import SectionTitle from './SectionTitle';
import ExternalLink from './ExternalLink';
import {
  DEVICE_THRESHOLD,
} from '../index';

class JOSM extends Component {
  render() {

    const firstLink = (
      <ExternalLink data={{
        name: 'Geohash plugin',
        url: 'https://wiki.openstreetmap.org/wiki/JOSM/Plugins/GeoHash',
        gaMessage: 'a link from the JOSM section',
      }} isCentered={true} />
    );
    const secondLink = (
      <ExternalLink data={{
        name: 'KartaView plugin',
        url: 'https://wiki.openstreetmap.org/wiki/JOSM/Plugins/KartaView',
        gaMessage: 'a link from the JOSM section',
      }} isCentered={true} />
    );

    return (
      <div id="lp-josm" className="lp-josm-container">
        <SectionTitle section="josm" text="JOSM Plugins" />
        <div className="lp-text-description">
          The JOSM plugins provide a comprehensive toolset, designed to seamlessly fit into mappers' routine workflows. These plugins facilitate the addition of a GeoHash grid-dependent layer that can be configured, or encompass KartaView coverage and sign detections. Access to our plugins can be attained via the JOSM plugin preferences.
        </div>
        <MediaQuery minWidth={DEVICE_THRESHOLD + 1}>
          <div className="lp-links">
            {firstLink}
            <span />
            {secondLink}
          </div>
        </MediaQuery>
        <MediaQuery maxWidth={DEVICE_THRESHOLD}>
          <div className="lp-links lp-mobile">
            {firstLink}
            {secondLink}
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default JOSM;



// WEBPACK FOOTER //
// ./src/components/JOSM.js